import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { PDFViewerPlugin } from './definitions';
import { CAPACITOR_PDF_VIEWER_PLUGIN } from '../pluginConstants';

const PDFViewerRaw = registerPlugin<PDFViewerPlugin>(CAPACITOR_PDF_VIEWER_PLUGIN);
const PDFViewer = withBridgedStackTrace(PDFViewerRaw, CAPACITOR_PDF_VIEWER_PLUGIN);

export * from './definitions';
export { PDFViewer };
